import React from 'react';
import { Switch, Route } from 'react-router-dom';

import List from './List';
import Edit from './Edit';

export default () => (
	<Switch>
		<Route path="/admin/appeals" exact component={List} />
		{/*<Route path="/admin/appeals/create" component={Edit} />*/}
		<Route path="/admin/appeals/:id" component={Edit} />
	</Switch>
);
